import { ArrowUpRight } from 'lucide-react';
import { JANE_URL } from '../data/site';

export default function BookButton({
  label = 'Book a Massage',
  variant = 'primary',
  size = 'md',
  className = '',
  testId = 'book-massage-btn',
}) {
  const base =
    'group inline-flex items-center justify-center gap-2.5 rounded-full font-semibold tracking-wide transition-[background-color,color,transform,box-shadow] duration-300 active:scale-[0.97]';
  const sizes = {
    md: 'px-7 py-3.5 text-sm',
    lg: 'px-9 py-4 text-base',
  };
  const variants = {
    primary:
      'bg-brand-teal text-brand-cream hover:bg-brand-ink shadow-[0_14px_34px_-14px_rgba(32,86,82,0.65)] hover:shadow-[0_18px_40px_-14px_rgba(19,42,38,0.6)]',
    ghost:
      'border border-brand-ink/25 text-brand-ink hover:border-brand-ink hover:bg-brand-ink hover:text-brand-cream',
    cream:
      'bg-brand-cream text-brand-ink hover:bg-brand-sage',
  };
  return (
    <a
      data-testid={testId}
      href={JANE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
    >
      {label}
      <ArrowUpRight
        className={`${size === 'lg' ? 'size-5' : 'size-4'} transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5`}
      />
    </a>
  );
}
